/* eslint-disable no-unused-vars */
import React from 'react';
import style from './searchResult.module.scss';
import isEmpty from 'lodash-es/isEmpty';
import reduce from 'lodash-es/reduce';
import { useSearchParams } from 'react-router-dom';
import { selectStartTags } from 'store/tagsSlice';
import { useAppSelector } from 'store/hooks';
import cx from 'classnames';

export default function SearchResult({
  isResources,
}: {
  isResources: boolean;
}) {
  const startTags = useAppSelector(selectStartTags);

  const resultText = isResources
    ? 'Результаты поиска по словам:'
    : 'Поиск не дал результатов:';

  const [searchParams] = useSearchParams();
  const isLiked = searchParams.get('only_liked');
  const isUploaded = searchParams.get('only_uploaded');

  return (
    <div className={style.container}>
      <span className={cx(style.result, 'adaptive-f32')}>{resultText}</span>
      <span
        className={cx(
          style.words,
          'adaptive-f24',
          'adaptive-searchResult__words'
        )}
      >
        {isLiked ? 'понравившееся' : ''}
        {isUploaded ? 'загруженное' : ''}
        {(isLiked || isUploaded) && !isEmpty(startTags) ? ', ' : ''}
        {reduce(startTags, (acc, tag) => acc + `${tag.name}, `, '').slice(
          0,
          -2
        )}
      </span>
    </div>
  );
}
